import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';
import login from '../assets/favicon.png';
import Image from './Image';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const logo = (
    <Box sx={{ width: 200, ...sx }}>
      <Image visibleByDefault disabledEffect alt="login" src={login} />
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="/">{logo}</RouterLink>;
}
